const extractRatingData = (summaryData) => {
  if (typeof summaryData === 'undefined' || summaryData === null || summaryData === '') {
    return null;
  }

  const okendo_summarydata = JSON.parse(summaryData);
  let reviews_average = Number(okendo_summarydata.reviewAverageValue);
  const review_count = Number(okendo_summarydata.reviewCount);

  if (review_count === 0 || reviews_average === 0 || isNaN(reviews_average)) {
    return null;
  }

  if (reviews_average < 1) {
    reviews_average = 1.0;
  } else if (reviews_average > 5) {
    reviews_average = 5.0;
  }

  return { reviews_average, review_count };
};

const getRatingHTML = (ratingData, productUrl) => {
  if (!ratingData || Number(ratingData.review_count) === 0 || Number(ratingData.reviews_average) === 0) {
    return '';
  }
  const { reviews_average, review_count } = ratingData;

  // Always show 5 stars total, with filled, fractional, and empty grey stars
  const rating = Number(reviews_average);
  let stars_html = '';
  
  const uniqueId = Math.random().toString(36).substring(2, 9);
  
  for (let i = 1; i <= 5; i++) {
    if (rating >= i) {
      // Full black star
      stars_html += `<svg aria-hidden="true" aria-label="Rating icon" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.6842 10.1897L10.5874 12.5454L9.55157 8.10544L13 5.11807L8.45894 4.73281L6.6842 0.545441L4.90946 4.73281L0.368408 5.11807L3.81683 8.10544L2.78104 12.5454L6.6842 10.1897Z" fill="black" />
        </svg>`;
    } else if (rating > i - 1) {
      // Fractional / half star
      const percentage = Math.round((rating - (i - 1)) * 100);
      stars_html += `<svg aria-hidden="true" aria-label="Rating icon" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="star-grad-${uniqueId}-${i}">
              <stop offset="${percentage}%" stop-color="black" />
              <stop offset="${percentage}%" stop-color="#e0e0e0" />
            </linearGradient>
          </defs>
          <path d="M6.6842 10.1897L10.5874 12.5454L9.55157 8.10544L13 5.11807L8.45894 4.73281L6.6842 0.545441L4.90946 4.73281L0.368408 5.11807L3.81683 8.10544L2.78104 12.5454L6.6842 10.1897Z" fill="url(#star-grad-${uniqueId}-${i})" />
        </svg>`;
    } else {
      // Empty grey star
      stars_html += `<svg aria-hidden="true" aria-label="Empty rating icon" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.6842 10.1897L10.5874 12.5454L9.55157 8.10544L13 5.11807L8.45894 4.73281L6.6842 0.545441L4.90946 4.73281L0.368408 5.11807L3.81683 8.10544L2.78104 12.5454L6.6842 10.1897Z" fill="#e0e0e0" />
        </svg>`;
    }
  }
  
  return `<a
      href="${productUrl}#pdp-reviews-anchor"
      target="_blank"
      class="product-tile__rating"
      data-product-tile-rating
      aria-label="Product rating ${Number(reviews_average).toFixed(1)} out of 5"
    >
      ${stars_html}
      <span>${Number(review_count)} review${review_count === 1 ? '' : 's'}</span>
    </a>
  `;
};  

export {
  extractRatingData,
  getRatingHTML
};
